import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {map} from "rxjs/operators";
import Api from "../../../../common/Api";
import {ElementTypeDto} from "../../../../common/apis/Elements";


export function useFindAllElementTypesQuery(): UseQueryResult<ElementTypeDto[], any> {
    return useQuery({
        queryKey: ["elements.supported-element-types"],
        queryFn: () => Api.elements.getTypes()
                .pipe(
                        map((response) => response.response as ElementTypeDto[])
                )
                .toPromise()
    });
}